import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {PostRequestUploadFile} from 'domain/usecases/others/facial-biometric';
import {RemoteFacialBiometricPostUploadFile} from 'data/usecases/others/facial-biometric/request/remote-post-upload-files';
import {FacialBiometricEndpoints} from 'main/factories/usecases/endpoints';

export const makePostRequestFacialBiometricUploadFile = (): PostRequestUploadFile =>
	new RemoteFacialBiometricPostUploadFile(
		makeBFFApiUrl(FacialBiometricEndpoints.register),
		makeAuthorizeHttpClientDecorator(),
	);
